const action = {
    GET_ADDRESS_LIST: 'GET_ADDRESS_LIST',
    SET_ADDRESS_LIST: 'SET_ADDRESS_LIST',
};

export default action;